import { render, staticRenderFns } from "./VerifyVignette.vue?vue&type=template&id=ec933d68&scoped=true"
import script from "./VerifyVignette.vue?vue&type=script&lang=js"
export * from "./VerifyVignette.vue?vue&type=script&lang=js"
import style0 from "./VerifyVignette.vue?vue&type=style&index=0&id=ec933d68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec933d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec933d68')) {
      api.createRecord('ec933d68', component.options)
    } else {
      api.reload('ec933d68', component.options)
    }
    module.hot.accept("./VerifyVignette.vue?vue&type=template&id=ec933d68&scoped=true", function () {
      api.rerender('ec933d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/VerifyVignette.vue"
export default component.exports